var map = {
	"./template.bet575": 1481,
	"./template.bet575.tsx": 1481,
	"./template.bet777": 1482,
	"./template.bet777.tsx": 1482,
	"./template.betgalaxy": 1483,
	"./template.betgalaxy.tsx": 1483,
	"./template.betprofessor": 1484,
	"./template.betprofessor.tsx": 1484,
	"./template.betroyale": 1485,
	"./template.betroyale.tsx": 1485,
	"./template.betstride": 1486,
	"./template.betstride.tsx": 1486,
	"./template.buffalobet": 1487,
	"./template.buffalobet.tsx": 1487,
	"./template.chromabet": 1488,
	"./template.chromabet.tsx": 1488,
	"./template.default": 665,
	"./template.default.tsx": 665,
	"./template.epicodds": 1489,
	"./template.epicodds.tsx": 1489,
	"./template.fiestabet": 1490,
	"./template.fiestabet.tsx": 1490,
	"./template.forsport": 1491,
	"./template.forsport.tsx": 1491,
	"./template.gigabet": 1492,
	"./template.gigabet.tsx": 1492,
	"./template.goldenbet888": 1493,
	"./template.goldenbet888.tsx": 1493,
	"./template.goldenrush": 1494,
	"./template.goldenrush.tsx": 1494,
	"./template.hyperbet": 1495,
	"./template.hyperbet.tsx": 1495,
	"./template.juicybet": 1496,
	"./template.juicybet.tsx": 1496,
	"./template.junglebet": 1497,
	"./template.junglebet.tsx": 1497,
	"./template.magnumbet": 1498,
	"./template.magnumbet.tsx": 1498,
	"./template.oldgill": 1499,
	"./template.oldgill.tsx": 1499,
	"./template.puntcity": 1500,
	"./template.puntcity.tsx": 1500,
	"./template.puntgenie": 1501,
	"./template.puntgenie.tsx": 1501,
	"./template.pyramidbet": 1502,
	"./template.pyramidbet.tsx": 1502,
	"./template.questbet": 1503,
	"./template.questbet.tsx": 1503,
	"./template.slambet": 1504,
	"./template.slambet.tsx": 1504,
	"./template.sterlingparker": 1505,
	"./template.sterlingparker.tsx": 1505,
	"./template.sugarcastle": 1506,
	"./template.sugarcastle.tsx": 1506,
	"./template.templebet": 1507,
	"./template.templebet.tsx": 1507,
	"./template.titanbet": 1508,
	"./template.titanbet.tsx": 1508,
	"./template.ts": 978,
	"./template.vikingbet": 1509,
	"./template.vikingbet.tsx": 1509,
	"./template.volcanobet": 1510,
	"./template.volcanobet.tsx": 1510,
	"./template.wellbet": 1511,
	"./template.wellbet.tsx": 1511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2441;